<template>
    <div>
        <material-card class="card-tabs" color="green">
            <v-flex slot="header">
                <v-tabs
                    v-model="activeTab"
                    color="transparent"
                    slider-color="white"
                >
                    <span
                        class="subheading font-weight-light mr-3"
                        style="align-self: center"
                        >Transactions:</span
                    >
                    <v-tab class="mr-3" href="#all">
                        All
                    </v-tab>
                    <v-tab class="mr-3" href="#bills">
                        Bills
                    </v-tab>
                    <v-tab class="mr-3" href="#payments">
                        Payments
                    </v-tab>
                    <v-spacer></v-spacer>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                style="color: #4caf50; background-color: #FFF"
                                class="ma-0 px-3"
                                v-on="on"
                            >
                                Statements
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-tile
                                v-for="(action, index) in getStatementActions()"
                                :key="index"
                                @click="action.action"
                            >
                                <v-list-tile-title>{{
                                    action.text
                                }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <v-btn
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0 px-3 ml-2"
                        v-if="currentRegID == regID"
                        @click="addStudent"
                        >Add Student</v-btn
                    >
                    <v-btn
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0 px-3 ml-2"
                        v-if="currentRegID == regID"
                        @click="openNewCreditCardModal()"
                        >New Credit Card</v-btn
                    >
                    <v-btn
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0 ml-2 px-3"
                        v-if="currentRegID == regID"
                        @click="openPaymentModal"
                        >Make Payment</v-btn
                    >
                </v-tabs>
            </v-flex>

            <v-tabs-items v-model="activeTab">
                <v-tab-item
                    v-for="tab in ['all', 'bills', 'payments']"
                    :key="tab"
                    :value="tab"
                >
                    <v-progress-linear
                        v-if="loading"
                        :indeterminate="true"
                        color="success"
                    ></v-progress-linear>
                    <v-expansion-panel v-if="!loading">
                        <v-expansion-panel-content
                            class=""
                            v-for="transaction in getTabList()"
                        >
                            <template v-slot:header class="my-0">
                                <div>
                                    <v-layout row class="pa-0 ma-0">
                                        <div class="subheading mb-1">
                                            {{
                                                getTransactionTitle(transaction)
                                            }}
                                        </div>
                                        <div
                                            class="subheading ml-2 mb-1 text-info"
                                            v-if="
                                                transaction.txnType == 'D' &&
                                                    transaction.student.nonUTA
                                            "
                                        >
                                            Non UTA
                                        </div>
                                    </v-layout>
                                    <div
                                        class="text--disabled subheading"
                                        v-if="transaction.txnType == 'C'"
                                    >
                                        {{ transaction.description }}
                                    </div>
                                    <div
                                        class="text--disabled subheading"
                                        v-if="transaction.txnType == 'D'"
                                    >
                                        {{
                                            transaction.student.enrollment
                                                .regType
                                        }}
                                    </div>
                                </div>
                                <v-spacer></v-spacer>
                                <div
                                    class="text--disabled body-2"
                                    v-if="
                                        transaction.txnType == 'D' &&
                                            isStudent(transaction) &&
                                            transaction.student.enrollment
                                                .lunchDoc
                                    "
                                >
                                    Lunch Document
                                </div>
                                <div
                                    class="text--disabled body-2"
                                    v-if="
                                        transaction.txnType == 'D' &&
                                            isStudent(transaction) &&
                                            transaction.student.enrollment
                                                .covidTest
                                    "
                                >
                                    Tested For Covid
                                </div>
                                <div
                                    class="text--disabled body-2"
                                    v-if="
                                        transaction.txnType == 'D' &&
                                            isStudent(transaction) &&
                                            transaction.student.cardPrinted
                                    "
                                >
                                    Registration Card Printed
                                </div>
                                <div
                                    class="text--disabled body-2"
                                    v-if="
                                        transaction.txnType == 'D' &&
                                            isStudent(transaction) &&
                                            transaction.student.bunkCardPrinted
                                    "
                                >
                                    Bunk Card Printed
                                </div>
                                <div
                                    class="text--disabled body-2"
                                    v-if="
                                        transaction.txnType == 'D' &&
                                            isStudent(transaction) &&
                                            transaction.student.busCardPrinted
                                    "
                                >
                                    Bus Card Printed
                                </div>
                                <div
                                    class="text-danger subheading"
                                    v-if="
                                        transaction.txnType == 'C' &&
                                            transaction.payment &&
                                            transaction.payment.isVoided
                                    "
                                >
                                    VOIDED
                                </div>
                                <div
                                    v-if="
                                        transaction.txnType == 'C' &&
                                            transaction.payment
                                    "
                                >
                                    <div
                                        class="text-danger subheading"
                                        v-if="
                                            transaction.payment.status ==
                                                'DECLINED'
                                        "
                                    >
                                        DECLINED
                                    </div>
                                    <div
                                        class="text-danger subheading"
                                        v-if="
                                            transaction.payment.status ==
                                                'ERROR'
                                        "
                                    >
                                        ERROR
                                    </div>
                                </div>
                                <v-spacer></v-spacer>
                                <div
                                    class="subheading text-xs-right pr-3"
                                    v-bind:class="{
                                        'text-danger':
                                            transaction.txnType == 'C',
                                        'text-success':
                                            transaction.txnType == 'D',
                                    }"
                                >
                                    {{ getTransactionAmount(transaction) }}
                                </div>
                            </template>
                            <v-card>
                                <v-flex xs12>
                                    <div v-if="transaction.txnType == 'C'">
                                        <v-card-text class="subheading mt-2">
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.dateCreated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Date Added:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.dateCreated
                                                            | time
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout row class="px-3 py-2">
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Payment Type:
                                                </div>
                                                <div>
                                                    {{
                                                        getPaymentType(
                                                            transaction
                                                        )
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout row class="px-3 py-2">
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Date:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.date | date
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.byUser"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    By User:
                                                </div>
                                                <div>
                                                    {{ transaction.byUser }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.lastUpdated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Last Updated:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.lastUpdated
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.lastUpdated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Last Updated By:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.lastUpdated
                                                            | time
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.note"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Note:
                                                </div>
                                                <div>
                                                    {{ transaction.note }}
                                                </div>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-layout row class="mb-2 pr-1">
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    small
                                                    outline
                                                    color="success"
                                                    @click="
                                                        openEmailReceiptDialog(
                                                            transaction
                                                        )
                                                    "
                                                >
                                                    Email Receipt
                                                </v-btn>
                                                <v-btn
                                                    small
                                                    outline
                                                    color="success"
                                                    @click="
                                                        printReceipt(
                                                            transaction
                                                        )
                                                    "
                                                >
                                                    Print Receipt
                                                </v-btn>
                                                <div
                                                    class="lapidus-transaction-button ml-2"
                                                >
                                                    <v-btn
                                                        small
                                                        :disabled="
                                                            currentRegID !=
                                                                regID
                                                        "
                                                        dark
                                                        color="default"
                                                        v-if="
                                                            allowRefund(
                                                                transaction
                                                            )
                                                        "
                                                        @click="
                                                            voidPayment(
                                                                transaction
                                                            )
                                                        "
                                                    >
                                                        Refund/Void Payment
                                                    </v-btn>
                                                    <v-btn
                                                        :disabled="
                                                            currentRegID !=
                                                                regID
                                                        "
                                                        small
                                                        dark
                                                        color="default"
                                                        class=""
                                                        v-if="
                                                            ![
                                                                'Refund',
                                                                'Void',
                                                            ].includes(
                                                                getPaymentType(
                                                                    transaction
                                                                )
                                                            )
                                                        "
                                                        @click="
                                                            updatePayment(
                                                                transaction
                                                            )
                                                        "
                                                    >
                                                        Update Payment
                                                    </v-btn>
                                                    <v-btn
                                                        small
                                                        dark
                                                        color="default"
                                                        :disabled="
                                                            currentRegID !=
                                                                regID
                                                        "
                                                        v-if="
                                                            ![
                                                                'CC',
                                                                'Refund',
                                                                'Void',
                                                            ].includes(
                                                                getPaymentType(
                                                                    transaction
                                                                )
                                                            )
                                                        "
                                                        @click="
                                                            deletePayment(
                                                                transaction
                                                            )
                                                        "
                                                    >
                                                        Delete Payment
                                                    </v-btn>
                                                    <v-btn
                                                        small
                                                        dark
                                                        :disabled="
                                                            currentRegID !=
                                                                regID
                                                        "
                                                        color="default"
                                                        v-if="
                                                            getPaymentType(
                                                                transaction
                                                            ) == 'CC' &&
                                                                isLaterDate(
                                                                    transaction.date
                                                                )
                                                        "
                                                        @click="
                                                            cancelScheduledPayment(
                                                                transaction
                                                            )
                                                        "
                                                    >
                                                        Cancel Scheduled Payment
                                                    </v-btn>
                                                </div>
                                            </v-layout>
                                        </v-card-actions>
                                    </div>

                                    <div v-else>
                                        <v-card-text class="subheading mt-2">
                                            <v-layout row class="px-3 py-2">
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Date:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.date | date
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.byUser"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    By User:
                                                </div>
                                                <div>
                                                    {{ transaction.byUser }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="isStudent(transaction)"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Registrantion Type:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.student
                                                            .enrollment.regType
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="
                                                    isStudent(transaction) &&
                                                        transaction.student
                                                            .enrollment
                                                            .regType == 'CUSTOM'
                                                "
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Weeks:
                                                </div>
                                                <div>
                                                    {{
                                                        getRegisteredWeeks(
                                                            transaction
                                                        )
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="
                                                    isStudent(transaction) &&
                                                        transaction.student
                                                            .enrollment
                                                            .insuranceCompany
                                                "
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Insurance Company:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.student
                                                            .enrollment
                                                            .insuranceCompany
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="
                                                    isStudent(transaction) &&
                                                        transaction.student
                                                            .enrollment
                                                            .insuranceID
                                                "
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Insurance ID:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.student
                                                            .enrollment
                                                            .insuranceID
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="
                                                    transaction.note &&
                                                        !isStudent(transaction)
                                                "
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Note:
                                                </div>
                                                <div>
                                                    {{ transaction.note }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.lastUpdated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Last Updated:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.lastUpdated
                                                            | time
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.lastUpdated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Last Updated By:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.lastUpdated
                                                            | time
                                                    }}
                                                </div>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-layout column>
                                                <div
                                                    v-if="
                                                        isStudent(transaction)
                                                    "
                                                    v-for="documentDetail in getDocumentsForStudent(
                                                        transaction.student
                                                    )"
                                                >
                                                    <v-btn
                                                        class="mt-2 ml-2 px-3"
                                                        @click="
                                                            openDocument(
                                                                documentDetail
                                                            )
                                                        "
                                                    >
                                                        <v-icon
                                                            color="red"
                                                            left
                                                            dark
                                                            >mdi-file-pdf</v-icon
                                                        >
                                                        {{
                                                            documentDetail.category +
                                                                " - " +
                                                                documentDetail.uploadedOn
                                                        }}
                                                        <v-icon right
                                                            >mdi-download</v-icon
                                                        >
                                                    </v-btn>
                                                    <v-btn
                                                        :disabled="
                                                            currentRegID !=
                                                                regID
                                                        "
                                                        v-if="
                                                            documentDetail.fileURL.includes(
                                                                'girlscamp-docs'
                                                            )
                                                        "
                                                        small
                                                        icon
                                                        @click.stop="
                                                            deleteDocument(
                                                                documentDetail
                                                            )
                                                        "
                                                        ><v-icon color="red"
                                                            >mdi-delete-forever</v-icon
                                                        ></v-btn
                                                    >
                                                </div>
                                            </v-layout>
                                            <v-spacer></v-spacer>
                                            <v-layout
                                                align-end
                                                justify-end
                                                class="mb-1 mr-1"
                                            >
                                                <v-btn
                                                    v-if="
                                                        isStudent(transaction)
                                                    "
                                                    small
                                                    :disabled="
                                                        currentRegID != regID
                                                    "
                                                    color="blue-grey"
                                                    class="white--text mr-2"
                                                    @click="
                                                        openUploadDocumentDialog(
                                                            transaction.student
                                                        )
                                                    "
                                                >
                                                    Upload Document
                                                    <v-icon right dark
                                                        >mdi-cloud-upload</v-icon
                                                    >
                                                </v-btn>
                                                <v-btn
                                                    :disabled="
                                                        currentRegID != regID
                                                    "
                                                    small
                                                    class="mr-2"
                                                    v-if="
                                                        transaction.student
                                                            .nonUTA &&
                                                            isStudent(
                                                                transaction
                                                            )
                                                    "
                                                    @click="
                                                        editStudentInfo(
                                                            transaction.student
                                                        )
                                                    "
                                                    color="default"
                                                    dark
                                                >
                                                    Update Student
                                                </v-btn>
                                                <v-btn
                                                    v-if="
                                                        isStudent(transaction)
                                                    "
                                                    :disabled="
                                                        currentRegID != regID
                                                    "
                                                    color="default"
                                                    dark
                                                    small
                                                    v-on:click="
                                                        openTransactionDialog(
                                                            transaction.student
                                                        )
                                                    "
                                                >
                                                    Update
                                                </v-btn>
                                                <v-btn
                                                    v-if="
                                                        isStudent(transaction)
                                                    "
                                                    small
                                                    color="default"
                                                    dark
                                                    v-on:click="
                                                        printCovidTestLabel(
                                                            transaction.student
                                                        )
                                                    "
                                                >
                                                    Print Covid Test Label
                                                </v-btn>
                                                <v-btn
                                                    v-if="
                                                        !isStudent(transaction)
                                                    "
                                                    small
                                                    color="default"
                                                    dark
                                                    v-on:click="
                                                        openEditAmountDialog(
                                                            transaction
                                                        )
                                                    "
                                                >
                                                    Update
                                                </v-btn>
                                            </v-layout>
                                        </v-card-actions>
                                    </div>
                                </v-flex>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-tab-item>
            </v-tabs-items>
        </material-card>
        <edit-transaction
            ref="editTransaction"
            :student="editingStudent"
            :account="account"
            :girlsCampAccount="girlsCampAccount"
            :refresh="refresh"
            :country="country"
            :newStudentSelected="newStudentSelected"
            :newStudents="newStudents"
        ></edit-transaction>

        <v-dialog v-model="changeTransactionAmountDialog" max-width="400">
            <v-card class="pa-4">
                <v-card-title class="headline pl-0">Change Amount</v-card-title>
                <v-text-field
                    class="mb-2"
                    v-model="changeTransactionAmount.amount"
                    type="number"
                    label="Amount"
                >
                </v-text-field>
                <v-text-field
                    class="mb-2"
                    v-model="changeTransactionAmount.note"
                    label="Note"
                >
                </v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="changeTransactionAmountDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="updateTransactionAmount"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline"
                    >Are you sure?</v-card-title
                >
                <v-card-text class="mb-2">{{
                    confirmationMessage
                }}</v-card-text>
                <v-text-field
                    class="mb-2 px-3"
                    v-if="isRefunding()"
                    type="number"
                    label="Refund Amount"
                    ref="refundAmount"
                    v-model="refundAmount"
                    :rules="refundAmountRules"
                    prefix="$"
                ></v-text-field>
                <v-text-field
                    class="px-3"
                    v-if="isRefunding()"
                    label="Refund Reason"
                    v-model="refundReason"
                ></v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="confirmDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="processAction"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="editDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-3"
                    >Update Payment</v-card-title
                >
                <div class="pa-3">
                    <v-text-field
                        v-if="editTransaction.type != 'CC'"
                        class="mb-2"
                        type="number"
                        label="Amount"
                        ref="amount"
                        prefix="$"
                        v-model="editTransaction.amount"
                        :rules="editTransaction.amountRules"
                    ></v-text-field>
                    <v-select
                        v-if="editTransaction.type != 'CC'"
                        class="mb-4"
                        :items="paymentTypes"
                        label="Payment Type"
                        v-model="editTransaction.type"
                        hide-details
                    ></v-select>
                    <v-menu
                        v-if="editTransaction.type != 'CC'"
                        v-model="editTransaction.datePickerMenu"
                        :close-on-content-click="false"
                        full-width
                        max-width="290"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                :value="formatedDate"
                                label="Date"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="editTransaction.date"
                            @change="datePickerMenu = false"
                        ></v-date-picker>
                    </v-menu>
                    <v-text-field
                        v-if="editTransaction.type != 'CC'"
                        class="mb-2"
                        label="Check Number"
                        ref="checkNumber"
                        v-model="editTransaction.checkNumber"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        label="Note"
                        v-model="editTransaction.note"
                    ></v-text-field>

                    <v-text-field
                        class="mb-2"
                        label="Receipt"
                        v-model="editTransaction.receipt"
                    ></v-text-field>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="editDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="processUpdate"
                    >
                        update
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="newStudentDialog" max-width="400">
            <new-student
                ref="newStudent"
                :onCreated="onNewStudentCreated"
                :closeNewStudentModal="closeNewStudentModal"
                :account="account"
                :studentToEdit="studentToEdit"
                :gradesSetup="gradesSetup"
                :refresh="refresh"
            ></new-student>
        </v-dialog>
        <v-dialog v-model="emailReceiptDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Email Receipt</v-card-title>
                <v-text-field
                    class="px-3"
                    v-model="emailAddress"
                    :rules="emailRules"
                    ref="emailReceipt"
                ></v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="emailReceiptDialog = false">Cancel</v-btn>
                    <v-btn
                        :loading="emailingReceipt"
                        color="success"
                        @click="emailReceipt"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="uploadDocumentDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Upload Document</v-card-title>
                <v-combobox
                    class="px-3"
                    autocomplete="new-password"
                    :items="documentTypes"
                    label="Document Type"
                    v-model="documentType"
                    ref="documentType"
                    :rules="required"
                ></v-combobox>
                <v-layout row>
                    <v-btn
                        small
                        outline
                        :disabled="currentRegID != regID"
                        class="mr-2 ml-3 mb-4 mt-0"
                        :loading="uploading"
                        @click="pickFile()"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <div v-if="files.length" class="mt-2 ml-2">
                        {{ files[0].name }}
                    </div></v-layout
                >
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    accept="image/*,.pdf"
                    @change="onFilePicked($event)"
                />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="closeUploadDocumentDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!files.length"
                        :loading="processing"
                        color="success"
                        @click="saveDocument()"
                    >
                        Save Document
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import editTransaction from "./EditTransaction.vue";
import addStudent from "./AddStudent.vue";
import moment from "moment";
import { loadOptions } from "../../../utils/smLookup.js";
import newStudent from "./newStudent.vue";
import { getDomain, sum } from "../../../utils/helpers.js";

export default {
    props: {
        transactions: Array,
        documents: Array,
        account: Object,
        girlsCampAccount: Object,
        refresh: Function,
        country: String,
        regID: String,
        currentRegID: String,
        openDialogForStudent: Object,
        openPaymentModal: Function,
        printStatement: Function,
        openEmailStatementDialog: Function,
        openNewCreditCardModal: Function,
        loading: Boolean,
    },
    components: {
        "edit-transaction": editTransaction,
        "add-student": addStudent,
        newStudent: newStudent,
    },
    data() {
        return {
            activeTab: "all",
            editingStudent: null,

            confirmationMessage: "",
            confirmDialog: false,
            confirmAction: null,
            refundReason: "",
            refundAmount: 0,
            refundTransactionAmount: {},
            paymentTypes: [],

            editDialog: false,
            newStudents: [],
            gradesSetup: [],
            documentTypes: [],

            editTransaction: {
                transactionID: "",
                amount: "",
                type: "",
                note: "",
                receipt: "",
                date: "",
                checkNumber: "",
                datePickerMenu: false,
                amountRules: [
                    (v) => !!v || v == 0 || "Amount Is Required",
                    (v) => !v || v >= 0 || "Amount Can't Be Negative",
                ],
            },

            newStudentDialog: false,

            processing: false,

            uploading: false,

            uploadDocumentForStudent: "",
            uploadDocumentDialog: false,
            documentType: "",
            files: [],

            charges: [],

            emailAddress: "",
            receiptToEmail: {},
            emailReceiptDialog: false,
            emailingReceipt: false,

            emailRules: [
                (value) => !!value || "Required.",
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            ],

            required: [(value) => !!value || "Required."],

            refundAmountRules: [
                (value) => {
                    if (value) {
                        return (
                            value <= this.refundTransactionAmount ||
                            "Can't be more than Payment Amount"
                        );
                    }

                    return !!value || "Refund Amount Is Required";
                },
            ],

            changeTransactionAmount: {
                amount: 0,
                id: "",
                original: "",
            },
            changeTransactionAmountDialog: false,

            studentToEdit: {},
        };
    },
    async created() {
        await this.loadPaymentTypes();
        await this.loadGradesSetup();

        await this.loadCharges();
        await this.loadDocumentTypes();
    },
    watch: {
        openDialogForStudent(newValue, oldValue) {
            if (this.openDialogForStudent && !this.editingStudent) {
                this.openTransactionDialog(this.openDialogForStudent);
            }
        },
    },
    computed: {
        formatedDate() {
            return this.editTransaction.date
                ? moment(new Date(this.editTransaction.date)).format("L")
                : "";
        },
    },
    methods: {
        async loadPaymentTypes() {
            this.paymentTypes = (await loadOptions("paymentType"))
                .map((v) => v.value)
                .filter((v) => v != "Credit Card");
        },
        async loadCharges() {
            const charges = await this.$http.get("api/girlscamp/getcharges");

            this.charges = charges;
        },
        getStatementActions() {
            return [
                { text: "Print", action: this.printStatement },
                { text: "Email", action: this.openEmailStatementDialog },
            ];
        },
        getTabList() {
            switch (this.activeTab) {
                case "bills":
                    return this.transactions.filter((t) => t.txnType == "D");
                case "payments":
                    return this.transactions.filter((t) => t.txnType == "C");
                default:
                    return this.transactions;
            }
        },
        getTransactionTitle(transaction) {
            if (transaction.txnType == "C")
                return "Payment - " + moment(transaction.date).format("L");

            const student = transaction.student;

            return (
                `${student.name} - ${student.hebName} (${student.class})` +
                (student.nonUTA ? " [" + student.school + "] " : "") +
                (transaction.description.startsWith("Girls Camp")
                    ? ""
                    : " - " + transaction.description)
            );
        },
        getTransactionAmount(transaction) {
            if (
                ["Refund", "Void"].includes(this.getPaymentType(transaction)) ||
                transaction.amount < 0
            )
                return "-$" + Math.abs(transaction.amount);

            return "$" + transaction.amount;
        },
        getPaymentType(transaction) {
            if (transaction.txnType == "D") return;

            return transaction.description.substr(
                0,
                transaction.description.indexOf(" ")
            );
        },
        getRegisteredWeeks(transaction) {
            const weeks = Object.keys(transaction.student.enrollment)
                .map((key) => {
                    if (
                        !key.startsWith("week") ||
                        !transaction.student.enrollment[key]
                    )
                        return;

                    return key.substring(4);
                })
                .filter(Boolean);

            return weeks.join(", ");
        },
        async addStudent() {
            this.newStudents = await this.loadStudents();

            this.openTransactionDialog({
                enrollment: {},
            });
        },
        async loadStudents() {
            const students = await this.$http.get(
                `api/lapidusDayCamp/getStudents?linkId=${
                    this.account.accountLinkID
                }&pin=${this.account.pinNum}`
            );

            const enrolledStudents = await this.$http.get(
                "api/lapidusDayCamp/GetEnrolledStudents?accountID=" +
                    this.account.accountID +
                    "&regID=" +
                    this.regID
            );

            return students.filter(
                (s) =>
                    !enrolledStudents
                        .map((student) => student.studentID)
                        .includes(s.studentID) && this.hasDayCamp(s)
            );
        },
        async loadGradesSetup() {
            this.gradesSetup = await this.$http.get(
                "api/lapidusDayCamp/getGradesSetup"
            );
        },
        hasDayCamp(student) {
            return this.gradesSetup.find((g) => g.grade == student.class)
                .isGirlsCampAvail;
        },
        openEditAmountDialog(transaction) {
            this.changeTransactionAmount = {
                amount: transaction.amount,
                note: transaction.note,
                original: transaction.amount,
                id: transaction.txnID,
            };

            this.changeTransactionAmountDialog = true;
        },
        rollbackChangeTransactionAmount(transaction) {
            this.changeTransactionAmountDialog = false;
        },
        async updateTransactionAmount() {
            try {
                this.processing = true;

                await this.$http.post("api/girlsCamp/updateTransactionAmount", {
                    txnID: this.changeTransactionAmount.id,
                    amount: this.changeTransactionAmount.amount,
                    note: this.changeTransactionAmount.note,
                    user: this.$store.state.authentication.user,
                });
                this.processing = false;

                this.changeTransactionAmountDialog = false;

                this.refresh();
            } catch (e) {
                this.processing = false;
            }
        },
        newStudentSelected(student) {
            if (!student) {
                this.editingStudent = {
                    enrollment: {},
                };

                return;
            }

            this.editingStudent = {
                isEnrolled: false,
                enrollment: {
                    regType: "NONE",
                    week1: false,
                    week2: false,
                    week3: false,
                    week4: false,
                    week5: false,
                    week6: false,
                    week7: false,
                    week8: false,
                    week9: false,
                },
                name: student.engName,
                studentID: student.studentID,
                hebName: student.hebName,
                class: student.class,
                charges: this.charges.map((charge) => {
                    charge.paymentAmount = charge.amount;

                    return charge;
                }),
                chosenClass: "",
                chosenBunk: "",
                total: 0,
            };
        },
        openTransactionDialog(student) {
            if (
                student.originalDuration == "NONE" &&
                student.enrollment.regType == "NONE"
            ) {
                student.charges = this.charges.map((charge) => {
                    charge.paymentAmount = charge.amount;

                    return charge;
                });

                student.total = sum(
                    student.charges.map((c) => +c.paymentAmount)
                );
            }

            //student.enrollment.amount;
            this.editingStudent = student;

            const studentCopy = JSON.parse(JSON.stringify(student));

            this.$refs.editTransaction.openDialog(studentCopy);
        },
        async printCovidTestLabel(student) {
            const newWindow = window.open("", "", "width=600, height=600");

            newWindow.document.write(this.createCovidTestLabel(student));

            await this.$http.post(
                "api/girlsCamp/SaveCovidLabelLog?studentID=" +
                    student.studentID +
                    "&user=" +
                    this.$store.state.authentication.user
            );
        },
        createCovidTestLabel(student) {
            let html = `<!DOCTYPE html>
            <html>
            <head>
            <style>
                table {
                  font-family: arial, sans-serif;
                  border-collapse: collapse;
                  width: 100%;
                }

                td, th {
                  border: 1px solid #dddddd;
                  text-align: left;
                  padding: 8px;
                }
                .text-table td, table {
                    border: none;
                    padding: 0px;
                    background-color: #fff;
                }

                .account-info {
                    font-family: arial, sans-serif;
                    text-align: left;
                    font-weight: 200;
                    margin-bottom: 0px;
                    margin-left: 10px;
                }

                tr:nth-child(even) {
                  background-color: #dddddd;
                }
                .regular-text {
                    margin-bottom: 2px;
                    margin-top: 0px;
                    font-size: 11px;
                }
            </style>
            </head>
            <body style="">

            <p class="regular-text" style="text-align: center;"><span style="font-size: 13pt;">
            <p class="regular-text" style="text-align: center;"><span style="font-size: 11pt;">
            <span style="font-family: arial, helvetica, sans-serif; font-size: 13px; font-weight: 700">Covid-19 Test Label</span></span></p>



            <div class="account-info">
            <p class="regular-text"><strong>${student.name +
                " " +
                this.account.lastName}</strong></p>
            <p class="regular-text"><strong>Class: </strong>${student.class}</p>
            <p class="regular-text"><strong>Insurance: </strong>${
                student.enrollment.insuranceCompany
                    ? student.enrollment.insuranceCompany +
                      (student.class.insuranceID
                          ? " - " + student.class.insuranceID
                          : "")
                    : ""
            }</p>

            <p class="regular-text"><strong>Address: </strong>${
                this.account.address1
            }</p>
            <p class="regular-text"><strong>Phone: </strong>${
                this.account.homePhone
            }</p>`;

            html += `
                </body>
            </html>`;

            return html;
        },
        isStudent(transaction) {
            return transaction.description.startsWith("Girls Camp");
        },
        async processAction() {
            if (this.isRefunding() && !this.$refs.refundAmount.validate(true))
                return;

            this.processing = true;

            try {
                await this.confirmAction();
            } catch (e) {
                this.processing = false;

                return;
            }

            if (this.isRefunding()) {
                this.$notify({
                    text: "Payment Refunded",
                    group: "notification",
                    type: "success",
                });
            }

            this.processing = false;

            this.confirmDialog = false;
            this.refundTransactionAmount = {};

            this.refresh();
        },
        updatePayment(transaction) {
            var lastIndex = transaction.description.lastIndexOf("#");
            const receipt = transaction.description.substring(lastIndex + 1);

            this.editTransaction.transactionID = transaction.txnID;
            this.editTransaction.receipt =
                receipt.trim() == this.getPaymentType(transaction)
                    ? ""
                    : receipt;
            this.editTransaction.date = new Date(transaction.date)
                .toISOString()
                .substr(0, 10);
            this.editTransaction.amount = transaction.amount;
            this.editTransaction.type = this.getPaymentType(transaction);
            this.editTransaction.note = transaction.note;
            this.editTransaction.checkNumber = this.getCheckNumber(transaction);

            this.editDialog = true;
        },
        getCheckNumber(transaction) {
            if (this.getPaymentType(transaction) == "CC") return "";

            var index = transaction.description.indexOf("#");
            const value = transaction.description.substring(index + 1);

            return value.substring(0, value.indexOf(" "));
        },
        async processUpdate() {
            if (
                this.editTransaction.type != "CC" &&
                !this.$refs.amount.validate(true)
            )
                return;

            this.processing = true;

            const {
                transactionID,
                receipt,
                date,
                amount,
                type,
                note,
                checkNumber,
            } = this.editTransaction;

            const data = {
                transactionID,
                receipt,
                date,
                amount,
                note,
                checkNumber: type == "Check" ? checkNumber : "",
                paymentType: type,
                user: this.$store.state.authentication.user,
            };

            try {
                await this.$http.post(
                    "api/lapidusDayCamp/UpdateTransaction",
                    data
                );
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;

            this.editDialog = false;
            this.refresh();
        },
        allowRefund(transaction) {
            return (
                this.getPaymentType(transaction) == "CC" &&
                moment(new Date(transaction.date)).isBefore(new Date())
            );
        },
        isRefunding() {
            return this.confirmationMessage.includes("Refund/Void");
        },
        voidPayment(transaction) {
            if (this.$store.state.authentication.user != "gc12") {
                this.$notify({
                    text: "Refund Disabled",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            this.confirmationMessage = "Refund/Void Payment";

            this.refundAmount = transaction.amount;
            this.refundTransactionAmount = transaction.amount;

            this.confirmAction = () => {
                return this.$http.post(`api/girlsCamp/voidPayment`, {
                    accountID: this.account.accountID,
                    user: this.$store.state.authentication.user,
                    paymentID: transaction.payment.paymentID,
                    amount: this.refundAmount,
                    reason: this.refundReason,
                });
            };

            this.confirmDialog = true;
        },
        deletePayment(transaction) {
            this.confirmationMessage =
                "This will delete the payment of $" + transaction.amount;

            this.confirmAction = () => {
                return this.$http.post(
                    "api/lapidusDayCamp/DeleteTransaction?transactionID=" +
                        transaction.txnID
                );
            };

            this.confirmDialog = true;
        },
        isLaterDate(date) {
            return moment(new Date(date)).isAfter(new Date());
        },
        cancelScheduledPayment(transaction) {
            if (!transaction.scheduleDetailID) {
                this.$notify({
                    group: "notification",
                    text: "Can't cancel payment without Schedule ID.",
                    type: "error",
                });

                return;
            }

            this.confirmationMessage =
                "This will cancel the payment of $" +
                transaction.amount +
                " scheduled for " +
                moment(transaction.date).format("L");

            this.confirmAction = () => {
                return this.$http.post(
                    "api/lapidusDayCamp/DeleteTransaction?transactionID=" +
                        transaction.txnID
                );
            };

            this.confirmDialog = true;
        },
        closeNewStudentModal() {
            this.newStudentDialog = false;
            this.studentToEdit = {};
            this.refresh();
        },
        onNewStudentCreated(student) {
            const existing = this.transactions
                .filter((t) => t.txnType == "D")
                .find((s) => (s.student.studentID = student.studentID));

            existing.engName = student.engName;
            existing.name = student.engName;
            existing.hebName = student.hebName;
            existing.school = student.school;
            existing.teacherName = student.teacherName;
            existing.teacherNumber = student.teacherNumber;
            existing.section = student.section;
            existing.dob = student.dob;
            existing.class = student.class;

            this.newStudentDialog = false;

            this.refresh();
        },
        editStudentInfo(student) {
            this.studentToEdit = student;

            this.newStudentDialog = true;
        },
        async loadDocumentTypes() {
            const documentTypes = await this.$http.get(
                "api/girlscamp/GetDocumentTypeList"
            );

            this.documentTypes = documentTypes;
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            this.uploading = false;
        },
        async openDocument(documentDetail) {
            const url = await this.$http.get(
                "/api/lapidusDayCamp/GetImmunizationsDocument?filePath=" +
                    documentDetail.fileURL
            );

            window.open(url);
        },
        openUploadDocumentDialog(student) {
            this.uploadDocumentForStudent = student;

            this.uploadDocumentDialog = true;
        },
        closeUploadDocumentDialog(student) {
            this.uploadDocumentDialog = false;
            this.files = [];
        },
        async saveDocument() {
            if (
                !this.$refs.documentType.validate(true) ||
                (Array.isArray(this.documentType) && !this.documentType.length)
            ) {
                this.$notify({
                    group: "notification",
                    text: "Missing Document Type",
                    type: "error",
                });

                return;
            }

            this.processing = true;

            try {
                var formData = new FormData();

                formData.append("image", this.files[0]);

                await this.$http.post(
                    "api/girlscamp/UploadFile?accountID=" +
                        this.account.accountID +
                        "&studentID=" +
                        this.uploadDocumentForStudent.studentID.trim() +
                        "&documentType=" +
                        this.documentType,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                this.processing = false;
                this.uploadDocumentDialog = false;
                this.files = [];
                this.documentType = [];

                this.refresh();
            } catch (e) {
                this.processing = false;
            }
        },
        getDocumentsForStudent(student) {
            return this.documents.filter(
                (doc) => doc.studentID == student.studentID.trim()
            );
        },
        deleteDocument(document) {
            this.confirmationMessage = `This will delete the ${
                document.category
            } document`;

            this.confirmAction = () => {
                return this.$http.post(
                    "api/girlscamp/DeleteFile?documentID=" + document.documentID
                );
            };

            this.confirmDialog = true;
        },
        getReceiptNumber(transaction) {
            const lastIndex = transaction.description.lastIndexOf("#");
            const lastSegment = transaction.description.substring(
                lastIndex + 1
            );

            return lastSegment.trim() == this.getPaymentType(transaction)
                ? ""
                : lastSegment;
        },
        createReceipt(transaction) {
            const receipt = this.getReceiptNumber(transaction);

            let html = `<!DOCTYPE html>
                <html style="margin: 10px; padding: 10px; border-style: solid;">
                <head>
                <style>
                table {
                  font-family: arial, sans-serif;
                  border-collapse: collapse;
                }

                td, th {
                  padding: 6px;
                }
                .no-border td, th {
                    border: none;
                }
                .account-info {
                    font-family: arial, sans-serif;
                    text-align: left;
                }
                .regular-text {
                    margin-bottom: 5px;
                    margin-top: 0px;
                }
                .title {
                    font-size: 25px;
                }
                </style>
                </head>
                <body>
                <p class="regular-text" style="text-align: center;"><span style="font-size: 13pt;">
            <strong><span style="font-family: arial, helvetica, sans-serif;">MACHNA TALMUDIS SATMAR</span>
            </strong></span></p>
                <p class="regular-text" style="text-align: center;"><span style="font-size: 13pt;"><strong>
                <span style="font-family: arial, helvetica, sans-serif;">מחנה תלמידות דסאטמאר</span> </strong></span></p>
                            <p class="regular-text" style="text-align: center;"><span style="font-size: 11pt;">
                            <span style="font-family: arial, helvetica, sans-serif;">— פענסילוועניע —</span></span></p>

                <p style="text-align: center;" class="account-info title"><strong>Receipt ${
                    receipt ? "#" + receipt : ""
                }</strong></p>

                <p style="text-align: right;" class="account-info"><strong>${moment(
                    transaction.date
                ).format("L")}</strong></p>

                <div class="account-info">
                <p class="regular-text"><strong>${
                    this.account.name
                }</strong></p>
                <p class="regular-text"><strong>Address: </strong>${
                    this.account.address1
                }</p>
                <p class="regular-text"><strong>Phone: </strong>${
                    this.account.homePhone
                }</p>`;

            if (this.account.emailAddress) {
                html += `<p class="regular-text"><strong>Email: </strong>${
                    this.account.emailAddress
                }</p>`;
            }

            html += `</div>`;

            html += `<table class="no-border" align="right" style="width: 45%;" border="1">
                    <tbody>
                    <tr>

                    <td>Payment Type</td>
                    <td style="text-align: right;"><strong>${this.getPaymentType(
                        transaction
                    )}</strong></td>
                    </tr>`;

            if (transaction.payment && transaction.payment.cardNumLast5) {
                html += `<tr>
                        <td>Card Last 4</td>
                        <td style="text-align: right;"><strong>${transaction.payment.cardNumLast5.substr(
                            -4
                        )}</strong></td>
                        </tr>`;
            }

            if (
                this.getPaymentType(transaction) &&
                this.getCheckNumber(transaction)
            ) {
                html += `<tr>
                        <td>Check Number</td>
                        <td style="text-align: right;"><strong>${this.getCheckNumber(
                            transaction
                        )}</strong></td>
                        </tr>`;
            }

            html += `<tr>
                    <td>Payment Amount</td>
                    <td style="text-align: right;"><strong>$${
                        transaction.amount
                    }</strong></td>
                    </tr>
                    </tbody>
                    </table>
                    </body>
                </html>`;

            return html;
        },
        printReceipt(transaction) {
            const newWindow = window.open(
                "",
                "Receipt",
                "width=800, height=800"
            );

            newWindow.document.write(this.createReceipt(transaction));
        },
        openEmailReceiptDialog(transaction) {
            this.receiptToEmail = transaction;

            this.emailAddress = this.account.emailAddress;

            this.emailReceiptDialog = true;
        },
        async emailReceipt() {
            if (!this.$refs.emailReceipt.validate(true)) return;

            this.emailingReceipt = true;

            try {
                await this.$http.post("api/girlscamp/emailLetter", {
                    emailAddress: this.emailAddress,
                    html: this.createReceipt(this.receiptToEmail),
                    subject: "Machna Talmudis Satmar Receipt",
                    accountID: this.account.accountID,
                });

                this.$notify({
                    text: "Email Sent",
                    group: "notification",
                    type: "success",
                });

                this.emailReceiptDialog = false;
            } catch (e) {
            } finally {
                this.emailingReceipt = false;
            }
        },
    },
};
</script>
<style>
.v-btn__content {
    color: unset;
}
/*
.lapidus-transaction-button
    .v-btn
    .v-btn--disabled
    .v-btn--small
    .theme--dark
    .default--text {
    color: rgba(0, 0, 0, 0.26) !important;
    background-color: rgba(0, 0, 0, 0.12) !important;
}*/

/*.lapidus-transaction-button.theme--dark.v-btn.v-btn--disabled,
.theme--dark.v-btn.v-btn--disabled .v-btn__loading,
.theme--dark.v-btn.v-btn--disabled .v-icon {
    color: rgba(0, 0, 0, 0.26) !important;
}

.lapidus-transaction-button.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
    background-color: rgba(0, 0, 0, 0.12) !important;
}*/
</style>
